<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="开始日期"><el-date-picker v-model="query.start" type="date" size="small" value-format="yyyy-MM-dd" /></el-form-item>
      <el-form-item label="结束日期"><el-date-picker v-model="query.end" type="date" size="small" value-format="yyyy-MM-dd" /></el-form-item>
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:dailyBalance:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('inventory:dailyBalance:list')" type="primary" size="small" @click="exportFile">导出</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
        <el-button v-if="isAuth('inventory:dailyBalance:list')" type="warning" size="small" @click="rebuildCurrent">重建当日</el-button>
        <el-button v-if="isAuth('inventory:dailyBalance:list')" size="small" @click="openRange">区间补跑</el-button>
      </el-form-item>
      <el-form-item label="关账日期"><el-date-picker v-model="closeDate" type="date" size="small" value-format="yyyy-MM-dd" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:dailyBalance:close')" type="warning" size="small" @click="closeBooks">关账</el-button>
        <el-button v-if="isAuth('inventory:dailyBalance:close')" size="small" @click="clearClose">反关账</el-button>
        <el-button v-if="isAuth('inventory:rebuildTask:list')" size="small" @click="$router.push('/inventory/rebuildTask')">重算任务</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="balanceDate" label="结存日期" width="120" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" />
      <el-table-column prop="materialName" label="产品名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
      <el-table-column v-if="inventoryQtyShowSupplier" prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
      <el-table-column prop="wareHousePath" label="仓库库位" min-width="180" show-overflow-tooltip />
      <el-table-column prop="beginQuantity" label="期初" width="110" align="right" />
      <el-table-column prop="inQuantity" label="入库" width="110" align="right" />
      <el-table-column prop="outQuantity" label="出库" width="110" align="right" />
      <el-table-column prop="endQuantity" label="期末" width="110" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
    <el-dialog title="日结区间补跑" :visible.sync="rangeVisible" width="420px" append-to-body>
      <el-form label-width="80px">
        <el-form-item label="开始日期"><el-date-picker v-model="range.start" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item>
        <el-form-item label="结束日期"><el-date-picker v-model="range.end" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="rangeVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="rangeLoading" @click="rebuildRange">执行</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin, today } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'
export default {
  name: 'DailyBalance',
  mixins: [authMixin, inventoryQtyShowSupplierMixin],
  data() { return { query: { start: today(), end: today(), materialCode: '', materialName: '' }, closeDate: '', rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, rangeVisible: false, rangeLoading: false, range: { start: '', end: '' } } },
  created() { this.loadInventoryQtyShowSupplierPolicy(); this.loadClose(); this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { start: today(), end: today(), materialCode: '', materialName: '' }; this.search() },
    load() {
      if (!this.query.start || !this.query.end) { this.$message.warning('日期不能为空'); return }
      this.loading = true
      request.get('/inventory/dailyBalance/list', { params: { start: this.query.start, end: this.query.end, materialCode: this.query.materialCode, materialName: this.query.materialName, pageIndex: this.pageIndex, pageSize: this.pageSize } })
        .then(res => {
          const body = res.data || {}
          this.rows = body.list || []
          this.total = body.totalCount || 0
        }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    exportFile() {
      if (!this.query.start || !this.query.end) { this.$message.warning('日期不能为空'); return }
      request.get('/inventory/dailyBalance/export', { params: { start: this.query.start, end: this.query.end, materialCode: this.query.materialCode, materialName: this.query.materialName }, responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '库存日结存.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => {})
    },
    loadClose() {
      request.get('/inventory/dailyBalance/closeInfo').then(res => { this.closeDate = res.data || '' }).catch(() => {})
    },
    rebuildCurrent() {
      if (!this.query.end) { this.$message.warning('请选择结束日期'); return }
      request.post('/inventory/dailyBalance/rebuild', { balanceDate: this.query.end }).then(() => {
        this.$message.success('重建完成；若仍无数据请确认结存日期与已审核出入库日期一致，或从最早业务日起用「区间补跑」')
        this.search()
      }).catch(() => {})
    },
    openRange() {
      this.range = { start: this.query.start || '', end: this.query.end || '' }
      this.rangeVisible = true
    },
    rebuildRange() {
      if (!this.range.start || !this.range.end) { this.$message.warning('请选择补跑区间'); return }
      if (this.range.start > this.range.end) { this.$message.warning('开始日期不能大于结束日期'); return }
      this.rangeLoading = true
      request.post('/inventory/dailyBalance/rebuild', { startDate: this.range.start, endDate: this.range.end }).then(() => {
        this.$message.success('补跑完成')
        this.rangeVisible = false
        this.search()
      }).catch(() => {}).finally(() => { this.rangeLoading = false })
    },
    closeBooks() {
      if (!this.closeDate) { this.$message.warning('关账日期不能为空'); return }
      request.post('/inventory/dailyBalance/close', { closeDate: this.closeDate }).then(() => { this.$message.success('关账成功，结存正在后台重算') }).catch(() => {})
    },
    clearClose() {
      request.post('/inventory/dailyBalance/clearClose').then(() => { this.closeDate = ''; this.$message.success('已反关账，结存正在后台重算') }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
